// import { useParams, Link } from "react-router-dom";
// import { Spin, Alert, Breadcrumb, Tabs, Badge } from "antd";
// import {
//   HomeOutlined,
//   UserOutlined,
//   CreditCardOutlined,
//   TeamOutlined,
//   AppstoreOutlined,
//   ExclamationCircleOutlined,
//   HistoryOutlined,
// } from "@ant-design/icons";
// import { useQuery } from "@tanstack/react-query";
// import {
//   useUserDetails,
//   useUpdateUserDetails,
//   useUpdateUserStatus,
//   useUpdateSubscription,
//   useSaveUpdationRequirement,
//   useSubscriptionHistory,
// } from "../../hooks/useUserProfile";
// import { fetchFeatures } from "../../services/userProfileService";
// import UserProfileHeader from "./components/UserProfileHeader";
// import SubscriptionDetails from "./components/SubscriptionDetails";
// import AttorneyDetails from "./components/AttorneyDetails";
// import PlanFeatures from "./components/PlanFeatures";
// import UpdationRequirement from "./components/UpdationRequirement";
// import { fetchBanks, fetchStates } from "../../services/orderService";
// import SubscriptionHistory from "./components/SubscriptionHistory";

// const UserProfile = () => {
//   const { id } = useParams();

//   // ── Fetch user data ───────────────────────────────────────────────────────
//   const {
//     data: rawUserData,
//     isLoading: isLoadingUser,
//     error: userError,
//   } = useUserDetails(id);

//   // ── Static mock: inject updation_requirement until API provides it ────────
//   // TODO: Remove this once the API returns updation_requirement in userData
//   const userData = rawUserData
//     ? {
//         ...rawUserData,
//         updation_requirement: rawUserData.updation_requirement ?? {
//           total_amount_to_be_paid: 25000,
//           gst_inclusion: 1,
//           attorney_numbers: ["12344", "12345", "1234"],
//           features: "1,2,5,6,16,20",
//         },
//       }
//     : rawUserData;

//   // ── Fetch ALL features once ───────────────────────────────────────────────
//   const { data: allFeatures = [], isLoading: isLoadingFeatures } = useQuery({
//     queryKey: ["allFeatures"],
//     queryFn: fetchFeatures,
//     staleTime: 10 * 60 * 1000,
//     retry: 2,
//   });

//   // Fetch Banks
//   const { data: bankData = [], isLoading: banksLoading } = useQuery({
//     queryKey: ["bank-master"],
//     queryFn: fetchBanks,
//     staleTime: 1000 * 60 * 60, // 1 hour
//   });

//   // Fetch States
//   const { data: statesData = [], isLoading: statesLoading } = useQuery({
//     queryKey: ["states"],
//     queryFn: fetchStates,
//     staleTime: 5 * 60 * 1000,
//   });

//   // ── Fetch subscription history ──────────────────────────────────────────
//   const {
//     data: subscriptionHistory = [],
//     isLoading: isLoadingHistory,
//     error: historyError,
//   } = useSubscriptionHistory(id);

//   // ── Mutations ─────────────────────────────────────────────────────────────
//   const updateUserMutation = useUpdateUserDetails();
//   const updateStatusMutation = useUpdateUserStatus();
//   const updateSubscriptionMutation = useUpdateSubscription();
//   const saveUpdationMutation = useSaveUpdationRequirement();

//   // ── Handlers ──────────────────────────────────────────────────────────────
//   const handleUpdateUser = (values) =>
//     updateUserMutation.mutateAsync({ userId: id, data: values });

//   const handleUpdateStatus = (status) =>
//     updateStatusMutation.mutateAsync({ userId: id, status });

//   const handleUpdateSubscription = (planData) =>
//     updateSubscriptionMutation.mutateAsync({ userId: id, planData });

//   const handleSaveUpdationRequirement = (formData) =>
//     saveUpdationMutation.mutateAsync({ userId: id, formData });

//   // ── Loading / Error states ────────────────────────────────────────────────
//   if (isLoadingUser) {
//     return (
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             <div
//               className="d-flex justify-content-center align-items-center"
//               style={{ minHeight: "60vh" }}
//             >
//               <Spin size="large" tip="Loading user profile..." />
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (userError) {
//     return (
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             <Alert
//               message="Error Loading Profile"
//               description={userError.message || "Failed to load user profile"}
//               type="error"
//               showIcon
//               className="mb-4"
//             />
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── Check if updation requirement exists ──────────────────────────────────
//   const hasUpdationRequirement = !!userData?.updation_requirement;

//   // ── Tabs ──────────────────────────────────────────────────────────────────
//   const tabItems = [
//     {
//       key: "subscription",
//       label: (
//         <span>
//           <CreditCardOutlined /> Subscription
//         </span>
//       ),
//       children: (
//         <SubscriptionDetails
//           subscriptionData={userData}
//           allFeatures={allFeatures}
//           onUpdateSubscription={handleUpdateSubscription}
//           isUpdating={updateSubscriptionMutation.isPending}
//         />
//       ),
//     },
//     {
//       key: "attorneys",
//       label: (
//         <span>
//           <TeamOutlined /> Attorneys
//         </span>
//       ),
//       children: (
//         <AttorneyDetails userData={userData} isLoading={isLoadingUser} />
//       ),
//     },
//     {
//       key: "features",
//       label: (
//         <span>
//           <AppstoreOutlined /> Features
//         </span>
//       ),
//       children: (
//         <PlanFeatures
//           allFeatures={allFeatures}
//           userFeatureIds={userData?.features ?? ""}
//           isLoading={isLoadingFeatures}
//         />
//       ),
//     },
//     {
//       key: "subscription_history",
//       label: (
//         <span>
//           <HistoryOutlined /> Subscription History
//         </span>
//       ),
//       children: (
//         <SubscriptionHistory
//           historyData={subscriptionHistory}
//           isLoading={isLoadingHistory}
//           error={historyError}
//           allFeatures={allFeatures}
//         />
//       ),
//     },
//     // Updation Requirement tab — shown last, only if requirement exists
//     ...(hasUpdationRequirement
//       ? [
//           {
//             key: "updation_requirement",
//             label: (
//               <Badge dot status="warning" offset={[6, 0]}>
//                 <span>
//                   <ExclamationCircleOutlined /> Updation Requirement
//                 </span>
//               </Badge>
//             ),
//             children: (
//               <UpdationRequirement
//                 userData={userData}
//                 allFeatures={allFeatures}
//                 onSave={handleSaveUpdationRequirement}
//                 isSaving={saveUpdationMutation.isPending}
//                 bankData={bankData}
//                 banksLoading={banksLoading}
//               />
//             ),
//           },
//         ]
//       : []),
//   ];

//   return (
//     <div className="main-content">
//       <div className="page-content">
//         <div className="container-fluid">
//           {/* Breadcrumb */}
//           <div className="row mb-3">
//             <div className="col-12">
//               <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                 <h4 className="mb-sm-0 font-size-18">User Profile</h4>
//                 <div className="page-title-right">
//                   <Breadcrumb
//                     items={[
//                       {
//                         title: (
//                           <Link to="/cms">
//                             <HomeOutlined /> CMS
//                           </Link>
//                         ),
//                       },
//                       {
//                         title: (
//                           <Link to="/cms/manage-customer">
//                             <UserOutlined /> Manage Customers
//                           </Link>
//                         ),
//                       },
//                       { title: "User Profile" },
//                     ]}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Profile Header */}
//           <UserProfileHeader
//             userData={userData}
//             onUpdateUser={handleUpdateUser}
//             onUpdateStatus={handleUpdateStatus}
//             isUpdatingProfile={updateUserMutation.isPending}
//             isUpdatingStatus={updateStatusMutation.isPending}
//             statesData={statesData}
//             statesLoading={statesLoading}
//           />

//           {/* Tabs */}
//           <Tabs
//             defaultActiveKey={
//               hasUpdationRequirement ? "updation_requirement" : "subscription"
//             }
//             items={tabItems}
//             size="large"
//             className="user-profile-tabs"
//           />
//         </div>
//       </div>

//       <style jsx>{`
//         .user-profile-tabs {
//           background: white;
//           padding: 20px;
//           border-radius: 12px;
//           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
//         }
//         :global(.user-profile-tabs .ant-tabs-nav) {
//           margin-bottom: 24px;
//         }
//         :global(.user-profile-tabs .ant-tabs-tab) {
//           padding: 12px 24px;
//           font-weight: 500;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default UserProfile;


import { useParams, Link, useNavigate } from "react-router-dom";
import { Spin, Alert, Breadcrumb, Tabs, Badge, Button } from "antd";
import {
  HomeOutlined,
  UserOutlined,
  CreditCardOutlined,
  TeamOutlined,
  AppstoreOutlined,
  ExclamationCircleOutlined,
  HistoryOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import {
  useSubscriptionDetails,
  useUpdateUserDetails,
  useUpdateUserStatus,
  useUpdateSubscription,
} from "../../hooks/useUserProfile";
import { fetchFeatures } from "../../services/userProfileService";
import UserProfileHeader from "./components/UserProfileHeader";
import SubscriptionDetails from "./components/SubscriptionDetails";
import AttorneyDetails from "./components/AttorneyDetails";
import PlanFeatures from "./components/PlanFeatures";
import { fetchBanks, fetchStates, fetchPlansByAttorneyType } from "../../services/orderService";
import SubscriptionHistory from "./components/SubscriptionHistory";

const UserProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // ── Fetch all profile data from a single endpoint ────────────────────────
  // pageData = { user, subscription_plan, attorney_numbers, subscription_logs }
  const {
    data: pageData,
    isLoading: isLoadingUser,
    error: userError,
  } = useSubscriptionDetails(id);


  // ── Derive shared TM count ────────────────────────────────────────────────
  // const totalTMCount = (pageData?.attorney_numbers ?? []).reduce(
  //   (s, a) => s + Number(a.tm_count ?? 0),
  //   0,
  // );

  const totalTMCount = pageData?.subscription_logs[0]?.total_tm_count


  //  console.log("from user-profile", pageData);

  // ── Normalize for UserProfileHeader ──────────────────────────────────────
  const headerData = pageData
    ? {
        ...pageData.user,
        is_active: pageData.user?.is_active,
        user_type:
          pageData.user?.is_attorney === 1
            ? "Attorney / IP Professional"
            : "Corporates",
        attorney_numbers: pageData.attorney_numbers ?? [],
        total_tm_count: totalTMCount,
        address: pageData.user?.billing_address,
      }
    : null;
    

  // ── Normalize for SubscriptionDetails ────────────────────────────────────
  const subscriptionData = pageData
    ? {
        ...pageData.subscription_plan,
        plan_price: parseFloat(pageData.subscription_logs[0]?.plan_price ?? pageData.subscription_logs[0]?.paid_amount ?? 0),
        plan_type: pageData.subscription_logs[0]?.plan_type ?? pageData.subscription_plan?.plan_type,
        attorney_numbers: (pageData.attorney_numbers ?? []).map(
          (a) => a.attorney_number,
        ),
        total_tm_count: pageData.subscription_logs[0]?.total_tm_count ?? totalTMCount,
        is_for_attorney: pageData.user?.is_attorney ?? 1,
        gst_inclusion: pageData.user?.gst_inclusion ?? 0,
        user_id: pageData.user?.id,
        is_active: pageData.user?.is_active,
        subscription_payment_status: pageData.subscription_control?.subscription_type,
        total_amount_paid: pageData.subscription_logs[0]?.paid_amount,
        features: pageData.subscription_plan?.features ?? "",
      }
    : null;

  // ── Fetch ALL features once ───────────────────────────────────────────────
  const { data: allFeatures = [], isLoading: isLoadingFeatures } = useQuery({
    queryKey: ["allFeatures"],
    queryFn: fetchFeatures,
    staleTime: 10 * 60 * 1000,
    retry: 2,
  });

  // ── Fetch plans to derive attorney limit from plan features ──────────────
  const isAttorney = pageData?.user?.is_attorney; // 1 or 0
  const planId = pageData?.subscription_plan?.plan_id;

  const { data: plansData } = useQuery({
    queryKey: ["plans-by-attorney", isAttorney],
    queryFn: () => fetchPlansByAttorneyType(isAttorney),
    enabled: isAttorney !== undefined && isAttorney !== null,
    staleTime: 10 * 60 * 1000,
  });

  // Find the active plan and extract number_of_attorney feature value
  const planLimit = (() => {
    if (!plansData?.data || !planId) return 0;
    const plans = Array.isArray(plansData.data) ? plansData.data : [];
    const plan = plans.find((p) => p.id === Number(planId));
    if (!plan) return 0;
    const feat = plan.features?.find((f) => f.feature_key === "number_of_attorney");
    return feat ? Number(feat.default_value || 0) : 0;
  })();


  // Fetch Banks
  const { data: bankData = [] } = useQuery({
    queryKey: ["bank-master"],
    queryFn: fetchBanks,
    staleTime: 1000 * 60 * 60, // 1 hour
  });

  // Fetch States
  const { data: statesData = [], isLoading: statesLoading } = useQuery({
    queryKey: ["states"],
    queryFn: fetchStates,
    staleTime: 5 * 60 * 1000,
  });

  // ── Subscription logs come from the same endpoint ────────────────────────
  const subscriptionHistory = pageData?.subscription_logs ?? [];
  const isLoadingHistory = isLoadingUser;
  const historyError = userError;

  // ── Mutations ─────────────────────────────────────────────────────────────
  const updateUserMutation = useUpdateUserDetails();
  const updateStatusMutation = useUpdateUserStatus();
  const updateSubscriptionMutation = useUpdateSubscription();

  // ── Handlers ──────────────────────────────────────────────────────────────
  const handleUpdateUser = (values) =>
    updateUserMutation.mutateAsync({ userId: id, data: values });

  const handleUpdateStatus = (status) =>
    updateStatusMutation.mutateAsync({ userId: id, status });

  const handleUpdateSubscription = (planData) => {
    // console.log("=== Update Subscription Payload ===");
    // const plainPayload = {};
    // planData.forEach((value, key) => { plainPayload[key] = value; });
    // console.log("planData (FormData entries):", plainPayload);
    return updateSubscriptionMutation.mutateAsync({ userId: id, planData });
  };

  // ── Loading / Error states ────────────────────────────────────────────────
  if (isLoadingUser) {
    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "60vh" }}
            >
              <Spin size="large" tip="Loading user profile..." />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (userError) {
    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <Alert
              message="Error Loading Profile"
              description={userError.message || "Failed to load user profile"}
              type="error"
              showIcon
              className="mb-4"
            />
          </div>
        </div>
      </div>
    );
  }

  // ── Check if updation requirement exists ──────────────────────────────────
  // const hasUpdationRequirement = !!userData?.updation_requirement;


  // ── Tabs ──────────────────────────────────────────────────────────────────
  const tabItems = [
    {
      key: "subscription",
      label: (
        <span>
          <CreditCardOutlined /> Subscription
        </span>
      ),
      children: (
        <SubscriptionDetails
          subscriptionData={subscriptionData}
          allFeatures={allFeatures}
          onUpdateSubscription={handleUpdateSubscription}
          isUpdating={updateSubscriptionMutation.isPending}
          rawAttorneyNumbers={pageData?.attorney_numbers ?? []}
        />
      ),
    },
    {
      key: "attorneys",
      label: (
        <span>
          <TeamOutlined /> Attorneys
        </span>
      ),
      children: (
        <AttorneyDetails
          userData={headerData}
          isLoading={isLoadingUser}
          planLimit={planLimit}
          userId={id}
          isAttorney={isAttorney}
        />
      ),
    },
    {
      key: "features",
      label: (
        <span>
          <AppstoreOutlined /> Features
        </span>
      ),
      children: (
        <PlanFeatures
          allFeatures={allFeatures}
          userFeatureIds={subscriptionData?.features ?? ""}
          isLoading={isLoadingFeatures}
        />
      ),
    },
    {
      key: "subscription_history",
      label: (
        <span>
          <HistoryOutlined /> Subscription History
        </span>
      ),
      children: (
        <SubscriptionHistory
          historyData={subscriptionHistory}
          isLoading={isLoadingHistory}
          error={historyError}
          allFeatures={allFeatures}
        />
      ),
    },
    // Updation Requirement tab — shown last, only if requirement exists
    // ...(hasUpdationRequirement
    //   ? [
    //       {
    //         key: "updation_requirement",
    //         label: (
    //           <Badge dot status="warning" offset={[6, 0]}>
    //             <span>
    //               <ExclamationCircleOutlined /> Updation Requirement
    //             </span>
    //           </Badge>
    //         ),
    //         children: (
    //           <UpdationRequirement
    //             userData={userData}
    //             allFeatures={allFeatures}
    //             onSave={handleSaveUpdationRequirement}
    //             isSaving={saveUpdationMutation.isPending}
    //             bankData={bankData}
    //             banksLoading={banksLoading}
    //           />
    //         ),
    //       },
    //     ]
    //   : []),
  ];

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* Breadcrumb */}
          <div className="row mb-3">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-3">
                  <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={() => navigate(-1)}
                    style={{ borderRadius: 6 }}
                  >
                    Back
                  </Button>
                  <h4 className="mb-sm-0 font-size-18">User Profile</h4>
                </div>
                <div className="page-title-right">
                  <Breadcrumb
                    items={[
                      {
                        title: (
                          <Link to="/cms">
                            <HomeOutlined /> CMS
                          </Link>
                        ),
                      },
                      {
                        title: (
                          <Link to="/cms/manage-customer">
                            <UserOutlined /> Manage Customers
                          </Link>
                        ),
                      },
                      { title: "User Profile" },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Profile Header */}
          <UserProfileHeader
            userData={headerData}
            onUpdateUser={handleUpdateUser}
            onUpdateStatus={handleUpdateStatus}
            isUpdatingProfile={updateUserMutation.isPending}
            isUpdatingStatus={updateStatusMutation.isPending}
            statesData={statesData}
            statesLoading={statesLoading}
          />

          {/* Tabs */}
          <Tabs
            // defaultActiveKey={
            //   hasUpdationRequirement ? "updation_requirement" : "subscription"
            // }
            items={tabItems}
            size="large"
            className="user-profile-tabs"
          />
        </div>
      </div>

      <style jsx>{`
        .user-profile-tabs {
          background: white;
          padding: 20px;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }
        :global(.user-profile-tabs .ant-tabs-nav) {
          margin-bottom: 24px;
        }
        :global(.user-profile-tabs .ant-tabs-tab) {
          padding: 12px 24px;
          font-weight: 500;
        }
      `}</style>
    </div>
  );
};

export default UserProfile;